interface Props {
  width?: string | number;
  height?: string | number;
  stroke?: string;
  className?: string;
}

const Help = ({
  width = '48',
  height = '48',
  stroke = '#1a1818',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 12.7 12.7"
    width={width}
    height={height}
    className={className}
  >
    <g>
      <g>
        <circle
          cx="6.35"
          cy="6.35"
          r="4.217"
          fill="none"
          stroke={stroke}
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.529"
          opacity="1"
        />
        <text
          xmlSpace="preserve"
          stroke={stroke}
          style={{
            color: stroke,
            lineHeight: '1.25',
            textAlign: 'center',
          }}
          x="6.392"
          y="8.977"
          strokeWidth="0.327"
          fontFamily="Source Sans Pro"
          fontSize="7.842"
          letterSpacing="0"
          opacity="1"
          textAnchor="middle"
          wordSpacing="0"
        >
          <tspan x="6.392" y="8.977" strokeWidth="0.327">
            ?
          </tspan>
        </text>
      </g>
    </g>
  </svg>
);

export default Help;
